<!--
 * @Description: 教职工详情 教学科研成果
 * @Author: 张天伟
 * @Date: 2023-03-08 17:11:12
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-04-19 17:00:30
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="科研项目编号" label-align="right" align="left" width="120px" span="2">{{item.kyxmbh}}</el-descriptions-item>
        <el-descriptions-item label="科研项目名称" label-align="right" align="left" width="120px" span="2">{{item.kyxmmc}}</el-descriptions-item>
        <el-descriptions-item label="项目负责人" label-align="right" align="left" width="120px" span="2">{{item.xmfzr}}</el-descriptions-item>
        <el-descriptions-item label="专项编号" label-align="right" align="left" width="120px" span="2">{{item.zxbh}}</el-descriptions-item>
        <el-descriptions-item label="获奖人员" label-align="right" align="left" width="120px" span="2">{{item.hjry}}</el-descriptions-item>
        <el-descriptions-item label="颁发机构" label-align="right" align="left" width="120px" span="2">{{item.bfjg}}</el-descriptions-item>
        <el-descriptions-item label="获奖日期" label-align="right" align="left" width="120px" span="2">{{item.hjrq}}</el-descriptions-item>
        <el-descriptions-item label="立项日期" label-align="right" align="left" width="120px" span="2">{{item.lxrq}}</el-descriptions-item>
        <el-descriptions-item label="结题日期" label-align="right" align="left" width="120px" span="2">{{item.jtrq}}</el-descriptions-item>
        <el-descriptions-item label="获奖等级" label-align="right" align="left" width="120px" span="2">{{item.hjdjbt}}</el-descriptions-item>
      </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongjiaoxuekeyanchengguo/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
